'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */

var arrayUtils = require('zero-lang/array');

function isGoodHead(head, rest) {
    var isGood = true;
    arrayUtils.some(rest, function (lin) {
        if (arrayUtils.indexOf(lin, head) > 0) {
            isGood = false;
        }
    });

    if (isGood) {
        arrayUtils.each(rest, function (lin) {
            if (arrayUtils.indexOf(lin, head) === 0) {
                lin.shift();
            }
        });
    }
    return isGood;
}

function eachHead(bases) {
    var result = [];
    var badLinearization = 0;

    while (bases.length) {
        var base = bases.shift();
        if (!base.length) {
            continue;
        }

        if (isGoodHead(base[0], bases)) {
            result.push(base.shift());
            badLinearization = 0;
        } else {
            badLinearization += 1;
            if (badLinearization === bases.length) {
                throw 'Bad Linearization';
            }
        }
        if (base.length) {
            bases.push(base);
        }
    }
    return result;
}

module.exports = function () {
    return eachHead(arrayUtils.map(arrayUtils.toArray(arguments), arrayUtils.toArray));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-net/~/zero-async/~/zero-oop/c3mro.js
 ** module id = 13
 ** module chunks = 0 1
 **/